/**
 * created on : 2019.0412
 * 广电文稿属性配置
 */
'use strict'
angular.module('manageSysManageManuscriptAttributeConfigModule', [
        'manuscriptAttributeConfigServiceModule'
    ])
    .controller('manageSysManageManuscriptAttributeConfigCtrl', ['$scope', 'trsHttpService', '$q', 'manuscriptAttributeConfigService', 'modalDialog', 'trsspliceString', function($scope, trsHttpService, $q, manuscriptAttributeConfigService, modalDialog, trsspliceString) {
        initStatus();
        initData();

        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
                "copyCurrPage": 1,
            };

            $scope.status = {
                keywords: '',
                dragStartIndex: '',
                dragStartItem: '',
            };

            $scope.data = {
                items: [],
                selectedArray: [],
            };
        }

        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            getAllAttributeConfig();
        }

        /**
         * [createdNew 新建属性]
         * @return {[type]} [description]
         */
        $scope.createdNew = function() {
            manuscriptAttributeConfigService.createdAttribute({
                isNew: true,
            }).then(function() {
                getAllAttributeConfig();
            });
        };

        /**
         * [selectAll 全选]
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            if ($scope.data.items.length != $scope.data.selectedArray.length && $scope.data.items.length > 0) {
                $scope.data.selectedArray = [];
                for (var i = 0; i < $scope.data.items.length; i++) {
                    $scope.data.selectedArray.push($scope.data.items[i]);
                }
            } else {
                $scope.data.selectedArray = [];
            }
        };

        /**
         * [singleSelect 单选]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelect = function(item) {
            var n = $scope.data.selectedArray.indexOf(item);
            n > -1 ? $scope.data.selectedArray.splice(n, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [editAttr 修改属性]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.modify = function(item) {
            manuscriptAttributeConfigService.createdAttribute({
                isNew: false,
                data: item
            }).then(function() {
                getAllAttributeConfig();
            });
        };

        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function(event, index, external, type) {
            return true;
        };

        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function(event, item, index) {
            $scope.status.dragStartIndex = index;
            $scope.status.dragStartItem = item;
        };

        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            }
            saveSort(index);
            // return item;
        };

        /**
         * [saveSort 保存排序]
         * @param  {[type]} index [description]
         * @return {[type]}       [description]
         */
        function saveSort(index) {
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'orderDocAttr',
                startId: $scope.status.dragStartItem.DOCEXATTRIBUTEID,
                targetId: $scope.data.items[index].DOCEXATTRIBUTEID,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                getAllAttributeConfig();
            });
        }

        /**
         * [getAllAttributeConfig 获取所有属性配置]
         * @return {[type]} [description]
         */
        function getAllAttributeConfig() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'querryDocAttr',
                attrDesc: $scope.status.keywords,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.data.selectedArray = [];
                angular.forEach(data, function(obj, index) {
                    if (obj.ENUMVALUE) {
                        obj.ENUMVALUE = obj.ENUMVALUE.replace(/,/g, '、');
                    }
                });
                $scope.data.items = data;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [fullTextSearch 检索]
         * @return {[type]} [description]
         */
        $scope.fullTextSearch = function(e) {
            if ((angular.isDefined(e) && e.keyCode == 13) || angular.isUndefined(e)) {
                getAllAttributeConfig();
            }
        };

        /**
         * [slideSwitch 更改开启状态]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.slideSwitch = function(item) {
            if (item.ATTRSTATUS == '1') {
                disabledAttribute(item).then(function() {
                    getAllAttributeConfig();
                });
            } else {
                EnabledAttribute(item).then(function() {
                    getAllAttributeConfig();
                });
            }
        };

        /**
         * [disabledAttribute 禁用属性]
         * @return {[type]} [description]
         */
        function disabledAttribute(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'stopDocAttrById',
                ObjectId: item.DOCEXATTRIBUTEID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('停用成功', '', 'success', false, function() {
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [EnabledAttribute 开启属性]
         * @param {[type]} item [description]
         */
        function EnabledAttribute(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_docexattribute',
                methodname: 'openDocAttrById',
                ObjectId: item.DOCEXATTRIBUTEID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('开启成功', '', 'success', false, function() {
                    defer.resolve();
                });
            });
            return defer.promise;
        }

        /**
         * [delete 删除]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.delete = function(item) {
            modalDialog.confirmModal('删除', '确认删除选中配置项？', function() {
                var params = {
                    serviceid: 'mlf_docexattribute',
                    methodname: 'deleteDocAttr',
                    docExAttributeIds: item ? item.DOCEXATTRIBUTEID : trsspliceString.spliceString($scope.data.selectedArray, 'DOCEXATTRIBUTEID', ',')
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                        getAllAttributeConfig();
                    });
                });
            });
        };
    }]);